module.exports = __webpack_public_path__ + "img/user-menu-exit.f5555e36.svg";